import { SecondaryFilter } from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import { OPERATORS_FILTERS } from "@/shared/constants/GeneralConstants";

export const DASHBOARD_TEMPLATE_MESSAGES = {
  CREATE: "Crear plantilla de dashboard",
  CANCEL: "Cancelar plantilla de dashboard",
  USED_FIELD: "Este campo ya esta seindo utilizado",
  CHOOSE_OPERATION: "Elegir operación",
  CHOOSE_TAG: "Elegir etiqueta",
  INDICATOR_NAME_REPEATED: "Ya existe un indicador con el mismo nombre",
  TAG_NAME_REPEATED: "Ya existe una etiqueta con el mismo nombre",
  GROUP_BY: "Agrupar por",
  SEE_BY: "Ver por",
  CANT_GROUP_BY_DATE: "No puede agrupar por dos fechas",
  TAG_IN_USE:
    "No se puede eliminar la etiqueta porque esta siendo usada en un indicador"
};

export const DASHBOARD_TEMPLATE_EVENTS = {
  RELOAD_QUERIES: "reloadQueries",
  DELETE_FILTER: "deleteFilter",
  SET_FILTER_ITEM: "setFilterItem",
  SET_ACTIONS_IN_FILTERS: "setActionInFilters",
  UPDATE_QUERY: "updateQuery",
  ADD_FILTER: "addFilter",
  SAVE_FILTER: "saveFilter",
  CANCEL_FILTER: "cancelFilter",
  CLOSE_INDICATOR_MODAL: "closeIndicatorModal",
  QUITE_COLLECTION_ITEM_OPTION_AND_PUT_IN_COLLECTION:
    "quitCollectionItemOptionAndPutInCollection",
  DELETE_COLLECTION: "deleteCollection",
  SET_COLLECTION_ITEM: "setCollectionItem",
  SET_CONFIG_CHART: "setConfigChart",
  SET_QUERY: "setQuery",
  SET_CHART_TYPE: "setChartType",
  SET_SECTIONS_OF_DASHBOARD: "setSectionsOfDashboard",
  TEMPLATE_SAVED: "templateSaved",
  UPDATE_SECTIONS_OF_DASHBOARD: "updateSectionsOfDashboard",
  CLEAN_ALL_DATA_OF_DASHBOARD_TEMPLATE: "cleanAllDataOfDashboardTemplate",
  ADD_COLLECTION_TO_SECTION_OF_DASHBOARD: "addCollectionToSectionOfDashboard",
  UPDATE_SECTION_NAME_OF_DASHBOARD: "updateSectionNameOfDashboard",
  DELETE_SECTION_OF_DASHBOARD: "deleteSectionOfDashboard",
  SET_COLLECTIONS_OPTIONS: "setCollectionsOptions",
  SET_TAGS: "setTags",
  ADD_TAG: "addTag",
  UPDATE_TAG: "updateTag",
  DELETE_TAG: "deleteTag",
  SET_INDICATORS: "setIndicators",
  ADD_INDICATOR: "addIndicator",
  UPDATE_INDICATOR: "updateIndicator",
  DELETE_INDICATOR: "deleteIndicator"
};

export const DATA_TYPE = {
  TIME_STAMP: "timestamp",
  LIST: "list",
  NUMBER: "number",
  STRING: "string",
  TIME_UNIT: "timeUnit"
};

export const DASHBOARD_OPERATORS = {
  BETWEEN: "Entre"
};

export const DASHBOARD_OPERATIONS = {
  COUNT: "COUNT"
};

export const DASHBOARD_FIELDS = {
  DOC_ID: "docId"
};

export const DASHBOARD_TEMPLATES_TITLE = "Consulta de plantillas de dashboard";

export const CHARTS_COLORS = [
  "#63c7e7", // color inicial (celeste claro)
  "#4aa9d4",
  "#368cbf",
  "#2b6fa4",
  "#235388",
  "#1b396b",
  "#0b3352" // color final (azul profundo)
];

export const DASHBOARD_TEMPLATE_EMPTY = [
  {
    name: "",
    tags: [],
    indicators: [],
    collectionsOptions: [],
    collections: [
      {
        collection: [{ id: "", name: "", fields: [] }],
        filters: [],
        groupBy: [],
        seeBy: [],
        chartName: "",
        query: {
          selectFields: {
            agregations: [],
            fields: []
          },
          principalView: "",
          filters: [],
          groupFields: []
        },
        chartData: {},
        chartType: "",
        chartColor: ""
      }
    ]
  }
];

export const DASHBOARD_TEMPLATE_FILTERS = {
  MAIN: {
    mainFilterKey: "Plantilla de dashboard",
    mainFilterName: "Todos",
    avatar: "mdi-animation",
    initial: true,
    secondaryFilters: [] as SecondaryFilter[],
    placeholder: "Escriba el nombre de la plantilla de Dashboard"
  },
  SECONDARY: {
    NAME: {
      name: "Nombre",
      placeholder: "Nombre de plantilla",
      key: "name",
      avatar: "mdi-form-textbox",
      type: "secondaryFilter",
      default: true,
      disabled: false,
      operators: OPERATORS_FILTERS,
      display: "unique"
    }
  }
};

export const INDICATOR = "indicator";
export const TAG = "tag";

export const DASHBOARD_OPERATIONS_LIST = [
  { id: "+", name: "Sumar" },
  { id: "-", name: "Restar" },
  { id: "/", name: "Dividir" },
  { id: "*", name: "Multiplicar" }
];

export const DASHBOARD_OPERATIONS_TAGAS = [
  { id: "COUNT", name: "Conteo de registros" },
  { id: "split_with", name: "Dividir con" },
  { id: "AVG", name: "Promedio" },
  { id: "MIN", name: "Mínimo" },
  { id: "MAX", name: "Máximo" },
  { id: "SUM", name: "Sumar" }
];

export const SEE_BY_LIST = [
  { id: "day", name: "Día" },
  { id: "week", name: "Semana" },
  { id: "month", name: "Mes" },
  { id: "year", name: "Año" }
];

export const FIELD_WITHOUT_DATA_ID = "Ninguno(a)";
export const FIELD_WITHOUT_DATA = {
  id: FIELD_WITHOUT_DATA_ID,
  name: FIELD_WITHOUT_DATA_ID
};

export const DEFAULT_COLOR = "#00000000";
